import type { ReactNode } from 'react'

export function Card({ onClick, children }: { onClick?: () => void; children: ReactNode }) {
  const base = 'rounded-lg border border-gray-200 bg-white transition-all'
  if (onClick) {
    return (
      <button onClick={onClick} className={`${base} w-full p-4 text-left hover:border-gray-300 hover:shadow-sm`}>
        {children}
      </button>
    )
  }
  return <div className={`${base} p-4`}>{children}</div>
}
